module.exports = __webpack_public_path__ + "media/images/tools-regular-33a4338d.svg";